var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sushi-invite-friends"},[_c('div',{staticClass:"sushi-invite-friends__content"},[_c('share-invite-widget')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58e49873","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/dashboard/page-dashboard-sushi/pages/sushi-invite-friends/sushi-invite-friends.vue
// module id = 2Q+L
// module chunks = 3